import autobind from "autobind-decorator";
import { action, observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";

import {
    CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, WithStyles
} from "@material-ui/core";
import { StyleRules, Theme, withStyles } from "@material-ui/core/styles";

import API from "./API";
import Button from "./Button";
import Text from "./Text";

type ClassNames = "container" | "loading" | "form" | "btn" | "input";

declare function subcribe_to_mailing_list(): void;

const apparence: {} = {
    apparence: "none",
    WebkitAppearance: "none",
    MozAppearance: "none"
};

const styles = (theme: Theme): StyleRules<ClassNames> => ({
    container: {
        backgroundColor: "#fafafa",
        justifyContent: "center",
        padding: theme.spacing.unit * 8,
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing.unit * 4,
        },
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing.unit,
        }
    },
    loading: {
        color: "white"
    },
    form: {
        display: "flex"
    },
    input: {
        margin: 0,
        flexGrow: 1,
        boxSizing: "border-box",
        boxShadow: "none",
        borderWidth: 2,
        borderRightWidth: 0,
        borderStyle: "solid",
        borderColor: theme.palette.grey[300],
        borderRadius: 5,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        fontSize: theme.typography.body1.fontSize,
        padding: theme.spacing.unit * 2,
        "&:focus": {
            borderColor: theme.palette.primary[500],
            outlineWidth: 0,
            appearance: "none",
            outline: 0
        },
        "&::-webkit-input-placeholder": {
            color: theme.palette.grey[300]
        },
        "&::-moz-placeholder": {
            color: theme.palette.grey[300]
        },
        "&:-moz-placeholder": {
            color: theme.palette.grey[300]
        },
        "&::-ms-input-placeholder": {
            color: theme.palette.grey[300]
        }
    },
    btn: {
        margin: 0,
        boxSizing: "border-box",
        fontSize: theme.typography.body1.fontSize,
        backgroundColor: theme.palette.primary[500],
        padding: theme.spacing.unit * 2,
        color: "white",
        borderStyle: "solid",
        borderWidth: 2,
        borderColor: theme.palette.primary[500],
        borderRadius: 0,
        borderTopRightRadius: 5,
        borderBottomRightRadius: 5,
    }
});

interface MailingListProps {
    noop?: boolean
}

@observer
class MailingList extends React.Component<WithStyles<ClassNames> & MailingListProps> {

    @observable public isLoading = false;
    @observable public isDone = false;
    @observable public email: string = "";

    @action
    public loading(loading: boolean) {
        this.isLoading = loading;
    }

    @action
    public done() {
        this.isLoading = false;
        this.isDone = true;
        this.email = "";
    }

    @autobind @action
    public closeDialog() {
        this.isDone = false;
    }

    @autobind
    public async submit() {
        const {email} = this;
        this.loading(true);
        API.subscribe(email);
        this.done();
        subcribe_to_mailing_list();

    }

    @autobind @action
    public setEmail(e: React.ChangeEvent<HTMLInputElement>) {
        this.email = e.target.value;
    }

    @autobind
    public onSubmit(e: React.ChangeEvent<HTMLFormElement>) {
        this.submit();
        e.preventDefault();
    }

    @autobind
    public submitClose(e: React.ChangeEvent<HTMLFormElement>) {
        this.closeDialog();
        e.preventDefault();
    }

    public render() {
        const {isLoading} = this;
        const {classes} = this.props;
        return (
            <Grid className={classes.container} container={true}>
                <Grid item={true} xs={12} sm={8} md={5}>
                    <Text align="center">
                    Subscribe to our newsletter to be always in the know
                    </Text>
                    <form className={classes.form} onSubmit={this.onSubmit}>
                        <input
                            value={this.email}
                            type="email"
                            placeholder="Your Email"
                            onChange={this.setEmail}
                            className={classes.input}
                            style={apparence}
                            required={true}
                        />
                        <button disabled={isLoading} type="submit" color="primary" className={classes.btn}>
                        {isLoading ? <CircularProgress size={32} classes={{ circle: classes.loading }} /> : "Subscribe"}
                        </button>
                    </form>
                    <Dialog open={this.isDone} onClose={this.closeDialog}>
                        <DialogTitle>We added you to the list</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                            Thank you for subscribing.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <form onSubmit={this.submitClose}>
                                <Button
                                    type="submit"
                                    onClick={this.closeDialog}
                                    primary={true}
                                    autoFocus={true}
                                >
                                Ok
                                </Button>
                            </form>
                        </DialogActions>
                    </Dialog>
                </Grid>
            </Grid>
        );
    }
}

export default withStyles(styles)(MailingList);



// WEBPACK FOOTER //
// ./src/components/MailingList.tsx